import { logError } from '../errorHandling';

export const StorageManager = {
  get: (key, defaultValue = []) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : defaultValue;
    } catch (error) {
      logError(`Error retrieving ${key} from storage:`, error);
      return defaultValue;
    }
  },

  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      logError(`Error saving ${key} to storage:`, error);
    }
  },

  update: (key, updateFn) => {
    const currentValue = StorageManager.get(key);
    const newValue = updateFn(currentValue);
    StorageManager.set(key, newValue);
    return newValue;
  }
};

// Failed questions manager
export const FailedQuestionsManager = {
  getAll: () => StorageManager.get('preguntasFalladas'),
  
  add: (question) => {
    StorageManager.update('preguntasFalladas', (current) => {
      if (!current.some(p => p.id === question.id)) {
        return [...current, question];
      }
      return current;
    });
  },
  
  remove: (questionId) => {
    StorageManager.update('preguntasFalladas', (current) =>
      current.filter(p => p.id !== questionId)
    );
  }
};

// Progress manager
export const ProgressManager = {
  getAll: () => StorageManager.get('progresoModulos', {}),
  
  updateModule: (moduleId, statistics) => {
    StorageManager.update('progresoModulos', (current) => ({
      ...current,
      [moduleId]: {
        ...current[moduleId],
        ...statistics,
        ultimaActualizacion: new Date().toISOString()
      }
    }));
  }
};